import { useEffect } from "react";
import useApiGet from "../Hooks/useGet";
import { BASE_URL_API, BASE_URL_API2 } from "../appconfig";
import Storelist from "../Store/Actions";
import useApiPost from "../Hooks/usePost";
import useApiPut from "../Hooks/usePut";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { logActivity, setAnalyticsUserName } from "./helper";

const Api = () => {
  const {
    setRequestsList,
    setBikeType_,
    setServiceType_,
    setAddressTypeList_,
    setStateList_,
    setBranchList_,
    setCityList_,
    setAddresslist_,
    setBikelist_,
    setCreateRequestData_,
    setLoading,
    clearCreateRequestData_,
    setServiceDetailsData_,
    setServiceRequiredList_,
    setSuperStarList_,
    setGearSystem_,
    setBrand_,
    setServicePackage_,
    setslotTime_,
    setServiceTrackingData_,
    setBranchDetail_,
    setBranchTechnician_,
    setAddTechnician,
    setAvailableTechnicianData_,
    AssignTechnician,
    setReschedule,
    editTechnician,
    setSlotModal,
    storeSlotData,
    ServiceDetailsStore,
    RequestUserStore,
    CreateRequestDetailsStore,
    PageStore,
    setOfferList_,
    BranchDetailStore,
  } = Storelist();

  const _GetRequestsList = useApiGet();
  const _GetbikeTypesList = useApiGet();
  const _GetbikeServiceTypeList = useApiGet();
  const _GetAddressTypeList = useApiGet();
  const _GetStateList = useApiGet();
  const _GetBranceList = useApiGet();
  const _GetCityList = useApiGet();
  const _GetRequestByID = useApiGet();
  const _GetOfferAndServiceRequired = useApiGet();
  const _GetSuperStarsList = useApiGet();
  const _GetGearSystem = useApiGet();
  const _GetServiceList = useApiPost();
  const _GetSericePackage = useApiGet();
  const _GetserviceMan = useApiGet();
  // POST
  const _Post_MobileNumber = useApiPost();
  const _Post_CreateRequest = useApiPost();
  const _Post_SlotDetails = useApiPost();
  const _BikeBrand = useApiPost();
  const _ServicePackageDetail = useApiPost();
  const _SlotTimes = useApiPost();
  const _verifyOTP = useApiPost();
  const _storeManagerStatusChange = useApiPost();
  const _verifyPincode = useApiPost();
  const _serviceTrackingById = useApiPost();
  const _GetBranch = useApiGet();
  const _getBranchTechnician = useApiPost();
  const _addSuperStar = useApiPost();
  const _technicianAttendance = useApiPost();
  const _getAvailableTechncian = useApiPost();
  const _assignTechncianToService = useApiPost();
  const _rescheduleService = useApiPost();
  const _initialAttendance = useApiPost();
  const _setSlots = useApiPost();
  const _getDatedSlots = useApiPost();
  const _setOrRevokeAttendance = useApiPost();
  const _deleteSuperstar = useApiPost();
  const _verifyEmailIdForNewRequest = useApiPost();

  // Warranty APIs
  const _GetStoreWarranties = useApiPost();
  const _GetWarrantyById = useApiGet();
  const _GetWarrantyService = useApiGet();
  const _GetWarrantyStatuses = useApiGet();
  const _CreateWarrantyServiceRequest = useApiPost();

  //PUT APIs
  const _editTechncian = useApiPut();

  //?-----------------------------------------------------------------------------------------------

  //! Technician CRUD APIs Starts
  /**
   * Add a new technician to the system
   * @param {Object} data - The new technician details
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const AddSuperStar = (data) => {
    // //console.log(data);
    _addSuperStar.Postdata(`${BASE_URL_API()}serviceman`, true, data);
  };
  useEffect(() => {
    setLoading(false);
    if (_addSuperStar?.data !== null) {
      if (_addSuperStar?.data?.status === 200) {
        setAddTechnician(false);
        console.log(_addSuperStar.payloadData.get("name"));
        const message = `${_addSuperStar.payloadData.get("name")} added as an new Technician`;
        logActivity("new Technician Added", {
          // technicianName: _addSuperStar.payloadData.get("name"),
          // role: _addSuperStar.payloadData.get("role"),
          message,
        });
        Swal.fire({
          title: "Technician Added Successfully",
          icon: "success",
          html: `
            <div class="w-full max-w-md mx-auto space-y-4  h-[90px] flex flex-col justify-between">
              <!-- Login ID -->
              <div class="flex text-left  justify-evenly items-center">
                <label class="text-sm font-medium mb-1 pt-9">Login ID :</label>
                <input id="loginId" 
                       type="text" 
                       readonly
                       value=${_addSuperStar?.data?.body?.data?.loginId}
                       class=" rounded-md px-3 py-2 text-sm  w-[60%] h-[30px] bg-[#F8F7F7] focus:outline-none focus:ring-0 text-center" />
              </div>
        
        
        
              <!-- Password -->
              <div class="flex  text-left  justify-evenly items-center">
                <label class="text-sm font-medium mb-1">Password :</label>
                <div class="relative  w-[60%] h-[30px]">
                  <input id="password" 
                         type="text" 
                         readonly
                         value="${_addSuperStar?.data?.body?.data?.password}"
                         class=" rounded-md px-3 py-2 pr-10 w-full text-sm h-[30px] bg-[#F8F7F7] focus:outline-none focus:ring-0 text-center"  />
                  <!-- Copy button -->
                  <button type="button" 
                          id="copyBtn"
                          class="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-blue-600">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M17.663 3.118c.225.015.45.032.673.05C19.876 3.298 21 4.604 21 6.109v9.642a3 3 0 0 1-3 3V16.5c0-5.922-4.576-10.775-10.384-11.217.324-1.132 1.3-2.01 2.548-2.114.224-.019.448-.036.673-.051A3 3 0 0 1 13.5 1.5H15a3 3 0 0 1 2.663 1.618ZM12 4.5A1.5 1.5 0 0 1 13.5 3H15a1.5 1.5 0 0 1 1.5 1.5H12Z" clip-rule="evenodd"></path><path d="M3 8.625c0-1.036.84-1.875 1.875-1.875h.375A3.75 3.75 0 0 1 9 10.5v1.875c0 1.036.84 1.875 1.875 1.875h1.875A3.75 3.75 0 0 1 16.5 18v2.625c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625v-12Z"></path><path d="M10.5 10.5a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963 5.23 5.23 0 0 0-3.434-1.279h-1.875a.375.375 0 0 1-.375-.375V10.5Z"></path></svg>
                  </button>
                </div>
              </div>
            </div>
          `,
          showConfirmButton: true,
          confirmButtonText: "Close",
          didOpen: () => {
            document.getElementById("copyBtn").addEventListener("click", () => {
              const password = document.getElementById("password").value;
              navigator.clipboard.writeText(password).then(() => {
                toast.success("Password copied to clipboard ✅", {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
              });
            });
          },
          didClose: () => {
            GetBranchTechnician(localStorage.getItem("BrId"));
            _addSuperStar.setData(null);
          },
          allowOutsideClick: false,
        });
      }
    } else if (_addSuperStar?.error !== null) {
      // //console.log(_addSuperStar?.error);
      Swal.fire({
        title: _addSuperStar?.error?.body?.message,
        icon: "error",
        didClose: () => {
          GetBranchTechnician(localStorage.getItem("BrId"));
          _addSuperStar.setError(null);
        },
      });
    }
  }, [_addSuperStar?.data, _addSuperStar?.error]);

  /**
   * Get the list of technicians for the given branch id
   * @param {string} [data] - The branch id
   * @param {string} [city] - The city id
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetBranchTechnician = (data, city) => {
    const branchId = data || localStorage.getItem("BrId");
    const cityId =
      city ||
      localStorage.getItem("cityId") ||
      localStorage.getItem("city") ||
      "";

    const payload = {
      branchId,
      city: cityId,
    };

    _getBranchTechnician.Postdata(
      `${BASE_URL_API()}getBranchTechnician`,
      true,
      payload,
    );
  };
  useEffect(() => {
    if (_getBranchTechnician?.data !== null) {
      if (_getBranchTechnician?.data?.status === 200) {
        setBranchTechnician_(_getBranchTechnician?.data?.body?.data);
      }
    }
    // setBranchTechnician(_getBranchTechnician?.data?.body?.data);
  }, [_getBranchTechnician?.data, _getBranchTechnician?.error]);

  /**
   * Gets the service man details for a given id
   * @param {string} id - The id of the service man
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetServiceMan = (id) => {
    _GetserviceMan.Getdata(`${BASE_URL_API()}serviceman?id=${id}`, true);
  };

  useEffect(() => {
    if (_GetserviceMan.data !== null) {
      if (_GetserviceMan.data.status === 200) {
        //console.log(_GetserviceMan?.data?.body?.data);
        setCreateRequestData_({
          technicianName: _GetserviceMan?.data?.body?.data?.name,
        });
        setCreateRequestData_({
          technicianEmailId: _GetserviceMan?.data?.body?.data?.emailId,
        });
        setCreateRequestData_({
          technicianMobileNo: _GetserviceMan?.data?.body?.data?.mobileNumber,
        });
        setCreateRequestData_({
          technicianEmergencyNo:
            _GetserviceMan?.data?.body?.data?.emergencyPhone,
        });
        setCreateRequestData_({
          technicianEmpId: _GetserviceMan?.data?.body?.data?.employeeId,
        });
        setCreateRequestData_({
          technicianBranch: _GetserviceMan?.data?.body?.data?.branch?._id,
        });
        setCreateRequestData_({
          technicianRole: _GetserviceMan?.data?.body?.data?.role,
        });
        setCreateRequestData_({
          technicianProfile: _GetserviceMan?.data?.body?.data?.profileUrl,
        });
        setCreateRequestData_({
          technicianAadhar: _GetserviceMan?.data?.body?.data?.aadhar,
        });
        setCreateRequestData_({
          technicianLicense:
            _GetserviceMan?.data?.body?.data?.drivingLicenseUrl,
        });
      }
    }
  }, [_GetserviceMan.data, _GetserviceMan.error]);


  useEffect(() => {

  }, [_editTechncian.data, _editTechncian.error])

  /**
   * Edit an existing technician in the system
   * @param {Object} data - The updated technician details
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const EditTechnician = (data) => {
    _editTechncian.Putdata(`${BASE_URL_API()}UpdateServiceMan`, true, data);
  };

  useEffect(() => {
    if (_editTechncian.data !== null) {
      if (_editTechncian.data.status === 200) {
        toast.success("Technician Updated successfully", {
          position: "top-center",
          onClose: () => editTechnician(""),
        });
        GetBranchTechnician(localStorage.getItem("BrId"));
      }
    } else if (_editTechncian.error !== null) {
      toast.error("something went wrong", { position: "top-center" });
    }
    _editTechncian.setData(null);
    _editTechncian.setError(null);
  }, [_editTechncian.data, _editTechncian.error]);

  /**
   * Deletes a superstar from the system
   * @param {string} id - The id of the superstar to be deleted
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const deleteSuperstar = (id) => {
    setLoading(true);
    _deleteSuperstar.Postdata(`${BASE_URL_API()}deleteSuperstar`, true, { id });
  };
  // useEffect(()=>{
  //   if(_deleteSuperstar?.data !== null){
  //     if(_deleteSuperstar?.data?.status === 200){
  //       toast.success(_deleteSuperstar?.data?.body?.message,{
  //         position:"top-center",

  //       });
  //       _deleteSuperstar.setData(null);
  //       _deleteSuperstar.setError(null);
  //       GetBranchTechnician(localStorage.getItem("BrId"));

  //     }
  //   }
  //   else if(_deleteSuperstar?.error !== null){
  //     toast.error(_deleteSuperstar?.error?.message);
  //   }
  //   setLoading(false);
  //   _deleteSuperstar.setData(null);
  //   _deleteSuperstar.setError(null);

  // },[_deleteSuperstar?.data,_deleteSuperstar?.error])
  //! Technician CRUD APIs Ends

  //?-----------------------------------------------------------------------------------------------

  //?-----------------------------------------------------------------------------------------------
  //! Request APIs Starts
  /**
   * Gets the list of service requests for the given branch id
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetRequestsList = (Auth) => {
    setLoading(true);
    _GetRequestsList.Getdata(
      `${BASE_URL_API()}serviceRequest?branch=${localStorage.getItem("BrId")}`,
      true,
    );
  };
  useEffect(() => {
    if (_GetRequestsList?.data !== null) {
      if (_GetRequestsList?.data?.status === 200) {
        setRequestsList(_GetRequestsList?.data?.body?.data);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }

    _GetRequestsList.setData(null);
    _GetRequestsList.setError(null);
  }, [_GetRequestsList?.data, _GetRequestsList?.error]);

  /**
   * Gets a service request by its id
   * @param {string} id - Id of the service request
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetRequestByID = (id) => {
    console.log(id);
    _GetRequestByID.Getdata(
      `${BASE_URL_API()}serviceRequestById?requestId=${id}`,
      true,
    );
  };
  useEffect(() => {
    if (_GetRequestByID?.data !== null) {
      if (_GetRequestByID?.data?.status === 200) {
        setServiceDetailsData_(_GetRequestByID?.data?.body?.data);
        TrackService({
          serviceId: _GetRequestByID?.data?.body?.data?.bikeRequest?._id,
        });
      }
      setLoading(false);
    }
  }, [_GetRequestByID?.data]);

  /**
   * Tracks a service request by its id
   * @param {object} data - Object containing the service id to track
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const TrackService = (data) => {
    _serviceTrackingById.Postdata(
      `${BASE_URL_API()}serviceTrackingByAdmin`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_serviceTrackingById?.data !== null) {
      if (_serviceTrackingById?.data?.status === 200) {
        setServiceTrackingData_(_serviceTrackingById?.data?.body?.data);
      }
      setLoading(false);
    }
  }, [_serviceTrackingById?.data]);

  /**
   * Gets the branch data by its id
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetBranchData = () => {
    _GetBranch.Getdata(
      `${BASE_URL_API()}getBranch?branchId=${localStorage.getItem("BrId")}`,
      true,
    );
  };
  useEffect(() => {
    if (_GetBranch?.data !== null) {
      if (_GetBranch?.data?.status === 200) {
        setBranchDetail_(_GetBranch?.data?.body?.data);
        localStorage.setItem(
          "branchName",
          _GetBranch?.data?.body?.data?.branchName,
        );
        const branchCity = _GetBranch?.data?.body?.data?.city;
        const branchCityId =
          typeof branchCity === "object" && branchCity !== null
            ? branchCity?._id || branchCity?.id
            : branchCity;
        if (branchCityId && !localStorage.getItem("cityId")) {
          localStorage.setItem("cityId", branchCityId);
          localStorage.setItem("city", branchCityId);
        }
        console.log(
          "[Branch Details - verify state field]",
          _GetBranch?.data?.body?.data,
        );
        // console.log("anlaytics starting",_GetBranch?.data?.body?.data?.branchName);
        // const name = setAnalyticsUserName(_GetBranch?.data?.body?.data?.branchName);
        // console.log("anlaytics ending",name);
      }
    }
  }, [_GetBranch.data]);
  //! Request APIs Ends
  //?-----------------------------------------------------------------------------------------------

  //?-----------------------------------------------------------------------------------------------
  //!ServiceBooking Related API starts

  /**
   * Checks if a mobile number is valid for booking a service
   * @param {Object} data - An object containing the mobile number to check
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const CheckMobile = (data) => {
    _Post_MobileNumber.Postdata(
      `${BASE_URL_API()}checkserviceRequestByMobileNumber`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_Post_MobileNumber?.data !== null) {
      if (_Post_MobileNumber?.data?.status === 200) {
        if (
          _Post_MobileNumber?.data?.status === 200 &&
          _Post_MobileNumber?.data?.body?.message === "Success"
        ) {
          setAddresslist_(_Post_MobileNumber?.data?.body?.data?.addresses);
          const isWarrantyClaim = !!RequestUserStore?.warrantyData;
          const allBikes = _Post_MobileNumber?.data?.body?.data?.bikes || [];
          const warrantyBikeId =
            RequestUserStore?.warrantyData?.bikeid?._id ||
            RequestUserStore?.warrantyData?.bicycle?._id;
          const warrantyBikeObj =
            RequestUserStore?.warrantyData?.bikeid ||
            RequestUserStore?.warrantyData?.bicycle;
          let bikes = allBikes;
          let matchedBike = null;
          if (isWarrantyClaim && warrantyBikeId) {
            matchedBike = allBikes.find(
              (b) => String(b?._id) === String(warrantyBikeId)
            );
            if (!matchedBike && warrantyBikeObj) {
              matchedBike = warrantyBikeObj;
            }
          }
          if (isWarrantyClaim) {
            const targetBike = matchedBike || bikes[0] || warrantyBikeObj;
            if (targetBike) {
              bikes = [
                targetBike,
                ...allBikes.filter(
                  (b) => String(b?._id) !== String(targetBike?._id)
                ),
              ];
            }
          }
          setBikelist_(bikes);
          let userdata = _Post_MobileNumber?.data?.body?.data?.data;
          setCreateRequestData_({ key: "user_id", value: userdata?.id });
          setCreateRequestData_({ key: "serviceType", value: "" });
          setCreateRequestData_({ key: "servicePackage", value: "" });

          if (isWarrantyClaim && bikes.length > 0) {
            const chosenBike = bikes[0];
            setCreateRequestData_({
              key: "bike_id",
              value: chosenBike?._id || "",
            });
            setCreateRequestData_({
              key: "bikeType",
              value: chosenBike?.bikeType?._id || chosenBike?.bikeType || "",
            });
            setCreateRequestData_({
              key: "gearSystem",
              value:
                chosenBike?.gearSystem?._id || chosenBike?.gearSystem || "",
            });
            setCreateRequestData_({
              key: "bikeName",
              value: chosenBike?.bikeName || "",
            });
            setCreateRequestData_({
              key: "bikeBrand",
              value: chosenBike?.brand?._id || chosenBike?.brand || "",
            });
            setCreateRequestData_({
              key: "bikeModel",
              value: chosenBike?.model || chosenBike?.modelName || "",
            });
            setCreateRequestData_({
              key: "frame_number",
              value:
                chosenBike?.frameNumber || chosenBike?.frame_number || "",
            });
            setCreateRequestData_({
              key: "amcAvailable",
              value: chosenBike?.amcAvailablity,
            });
            if (chosenBike?.amcId) {
              setCreateRequestData_({
                key: "amcId",
                value: chosenBike?.amcId,
              });
            }
          } else {
            setCreateRequestData_({ key: "bike_id", value: "" });
            setCreateRequestData_({ key: "bikeType", value: "" });
            setCreateRequestData_({ key: "bikeName", value: "" });
            setCreateRequestData_({ key: "bikeBrand", value: "" });
            setCreateRequestData_({ key: "bikeModel", value: "" });
            setCreateRequestData_({ key: "frame_number", value: "" });
          }

          setCreateRequestData_({ key: "bikeWeight", value: "" });
          setCreateRequestData_({ key: "bikeMileage", value: "" });
          setCreateRequestData_({
            key: "email",
            value: userdata?.emailId || RequestUserStore?.email || "",
          });
          setCreateRequestData_({
            key: "mobile",
            value: userdata?.imobilenumber || RequestUserStore?.mobile || "",
          });
          setCreateRequestData_({
            key: "name",
            value: userdata?.fullName || RequestUserStore?.name || "",
          });
          setCreateRequestData_({ key: "address_type", value: "" });
          setCreateRequestData_({ key: "full_address", value: "" });
          setCreateRequestData_({ key: "address_id", value: "" });
          setCreateRequestData_({ key: "branch", value: "" });
          setCreateRequestData_({ key: "serviceRequired", value: "" });
          setCreateRequestData_({ key: "date_time", value: "" });
          setCreateRequestData_({ key: "offer", value: "" });
          setCreateRequestData_({ key: "amount", value: "" });
          setCreateRequestData_({
            key: "member_on",
            value: userdata?.created
              ?.split("T")[0]
              ?.split("-")
              ?.reverse()
              ?.join("-"),
          });
          // setCreateRequestData_({key:'member_on',value:'date on'});
        } else {
          setAddresslist_([]);
          setBikelist_([]);
          setCreateRequestData_({ key: "user_id", value: null });
          setCreateRequestData_({ key: "serviceType", value: "" });
          setCreateRequestData_({ key: "servicePackage", value: "" });
          setCreateRequestData_({ key: "bike_id", value: "" });
          setCreateRequestData_({ key: "bikeType", value: "" });
          setCreateRequestData_({ key: "bikeName", value: "" });
          setCreateRequestData_({ key: "bikeBrand", value: "" });
          setCreateRequestData_({ key: "bikeModel", value: "" });
          setCreateRequestData_({ key: "bikeWeight", value: "" });
          setCreateRequestData_({ key: "bikeMileage", value: "" });
          setCreateRequestData_({ key: "name", value: "" });
          setCreateRequestData_({ key: "address_type", value: "" });
          setCreateRequestData_({ key: "full_address", value: "" });
          setCreateRequestData_({ key: "address_id", value: "" });
          setCreateRequestData_({ key: "frame_number", value: "" });
          setCreateRequestData_({ key: "branch", value: "" });
          setCreateRequestData_({ key: "serviceRequired", value: "" });
          setCreateRequestData_({ key: "date_time", value: "" });
          setCreateRequestData_({ key: "offer", value: "" });
          setCreateRequestData_({ key: "amount", value: "" });
          setCreateRequestData_({ key: "email", value: ""});
          
          setCreateRequestData_({
            key: "member_on",
            value: "",
          });
        }
      }
    }
  }, [_Post_MobileNumber?.data]);

  /**
   * Gets the list of bike types available for booking
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetbikeTypesList = (Auth) => {
    _GetbikeTypesList.Getdata(`${BASE_URL_API()}bikeType`, true);
  };
  useEffect(() => {
    if (_GetbikeTypesList?.data !== null) {
      if (_GetbikeTypesList?.data?.status === 200) {
        setBikeType_(_GetbikeTypesList?.data?.body?.data);
        setLoading(false);
      }
    } else {
    }
  }, [_GetbikeTypesList?.data]);

  /**
   * Gets the list of gear systems available for booking
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetgearSystemList = (Auth) => {
    setLoading(true);
    _GetGearSystem.Getdata(`${BASE_URL_API()}gearSystem`, true);
  };
  useEffect(() => {
    if (_GetGearSystem?.data !== null) {
      if (_GetGearSystem?.data?.status === 200) {
        setGearSystem_(_GetGearSystem?.data?.body?.data);
        // GetBrandList(true);
        setLoading(false);
      }
    } else {
    }
  }, [_GetGearSystem?.data]);

  /**
   * Gets the list of bike brands available for booking based on the given bike type
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @param {string} bikeType - The type of bike to filter the brands by
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetBrandList = (Auth, bikeType) => {
    if (!bikeType) {
      setBrand_([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    _BikeBrand.Postdata(`${BASE_URL_API()}bikeBrand`, true, { bikeType });
  };
  useEffect(() => {
    if (_BikeBrand?.data !== null) {
      if (_BikeBrand?.data?.status === 200) {
        setLoading(false);
        setBrand_(_BikeBrand?.data?.body?.data);
      }
    } else {
    }
  }, [_BikeBrand?.data]);

  /**
   * Gets the list of address types available for booking
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetAddressTypeList = (Auth) => {
    _GetAddressTypeList.Getdata(`${BASE_URL_API()}addressTypes`, true);
  };
  useEffect(() => {
    if (_GetAddressTypeList?.data !== null) {
      if (_GetAddressTypeList?.data?.status === 200) {
        setAddressTypeList_(_GetAddressTypeList?.data?.body?.data);
        GetStateList();
      }
    }
  }, [_GetAddressTypeList?.data]);

  /**
   * Gets the list of states available for booking
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetStateList = (Auth) => {
    _GetStateList.Getdata(`${BASE_URL_API()}jbcstates`, true);
  };
  useEffect(() => {
    if (_GetStateList?.data !== null) {
      if (_GetStateList?.data?.status === 200) {
        setStateList_(_GetStateList?.data?.body?.data);
      }
    }
  }, [_GetStateList?.data]);

  /**
   * Gets the list of cities available for booking based on the given state code
   * @param {string} stateCode - State code to filter the cities by
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetCityList = (stateCode) => {
    _GetCityList.Getdata(
      `${BASE_URL_API()}jbccitiesforstate?stateCode=${stateCode}`,
      true,
    );
  };
  useEffect(() => {
    if (_GetCityList?.data !== null) {
      if (_GetCityList?.data?.status === 200) {
        setCityList_(_GetCityList?.data?.body?.data);
      }
      setLoading(false);
    }
  }, [_GetCityList?.data]);

  /**
   * Gets the list of branches available for booking based on the given city
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @param {string} city - City to filter the branches by
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetBranchList = (Auth, city, bikeType) => {
    _GetBranceList.Getdata(
      `${BASE_URL_API()}jbclocations?city=${city}&bikeType=${bikeType || RequestUserStore.bikeType}&gearSystem=${RequestUserStore.gearSystem}`,
      true,
    );
  };
  useEffect(() => {
    if (_GetBranceList?.data !== null) {
      if (_GetBranceList?.data?.status === 200) {
        setBranchList_(_GetBranceList?.data?.body?.data);
        // GetOfferAndServiceRequiredList();
      }
    }
  }, [_GetBranceList?.data]);

  /**
   * Verify a pincode for a city
   * @param {Object} data - Object containing the pincode to be verified
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const verifyPincode = (data) => {
    setLoading(true);
    _verifyPincode.Postdata(`${BASE_URL_API()}verifyCityPincode`, true, data);
  };
  useEffect(() => {
    if (_verifyPincode?.data !== null) {
      if (_verifyPincode?.data?.status === 200) {
        setLoading(false);
        setCreateRequestData_({
          key: "state",
          value: _verifyPincode?.data?.body?.data?.city?.state,
        });
        GetCityList(_verifyPincode?.data?.body?.data?.city?.state);
        GetBranchList(true, _verifyPincode?.data?.body?.data?.city?._id);
        setCreateRequestData_({
          key: "city",
          value: _verifyPincode?.data?.body?.data?.city?._id,
        });
        GetOfferAndServiceRequiredList(
          true,
          _verifyPincode?.data?.body?.data?.city?._id,
        );
        if (RequestUserStore.selectedAddress) {
          const item = CreateRequestDetailsStore?.addresslist?.find(
            (obj) => obj._id === RequestUserStore.selectedAddress,
          );
          if (item) {
            setCreateRequestData_({ key: "pincode", value: item?.pincode });
            setCreateRequestData_({
              key: "addressName",
              value: item?.addressName,
            });
            setCreateRequestData_({
              key: "address_type",
              value: item?.addressType,
            });
            setCreateRequestData_({
              key: "full_address",
              value: item?.fullAddress,
            });
            setCreateRequestData_({ key: "address_id", value: item?._id });
            setCreateRequestData_({ key: "selectedAddress", value: "" });
          }
        }
      }
      _verifyPincode.setData(null);
    } else if (_verifyPincode.error) {
      setLoading(false);
      toast.error("sorry currently we are not available at your pincode", {
        position: "top-center",
        onClose: () => {
          _verifyOTP.setError(null);
          setCreateRequestData_({ key: "pincode", value: "" });
          // clearCreateRequestData_();
        },
      });
    }
  }, [_verifyPincode.data, _verifyPincode.error]);



  const verifyEmailIdForNewRequest = (data)=>{
    _verifyEmailIdForNewRequest.Postdata(`${BASE_URL_API()}event/verifyEmailId `,true,data)
  }
  useEffect(() => {
    if (_verifyEmailIdForNewRequest?.data !== null) {
      console.log(_verifyEmailIdForNewRequest?.data)
      if (_verifyEmailIdForNewRequest?.data?.body?.status === 200) {    
        console.log("trtttt",_verifyEmailIdForNewRequest?.data?.body?.data?.isUser)    
        if(_verifyEmailIdForNewRequest?.data?.body?.data?.isUser){
          toast.warn(_verifyEmailIdForNewRequest?.data?.body?.message)
          setCreateRequestData_({ key: "email", value: "" });
        }
      }

      _verifyEmailIdForNewRequest.setData(null);
    }
  }, [_verifyEmailIdForNewRequest.data, _verifyEmailIdForNewRequest.error]);

  /**
   * Gets the list services required for booking based on the given city
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @param {string} city - City to filter the offers and services by
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetOfferAndServiceRequiredList = (Auth, city) => {
    let url = `${BASE_URL_API()}serviceType?cityId=${city}`;
    if (RequestUserStore?.bike_id) {
      url += `&bikeid=${RequestUserStore?.bike_id}`;
    }
    _GetOfferAndServiceRequired.Getdata(url, true);
  };
  useEffect(() => {
    if (_GetOfferAndServiceRequired?.data !== null) {
      if (_GetOfferAndServiceRequired?.data?.status === 200) {
        setServiceRequiredList_(_GetOfferAndServiceRequired?.data?.body?.data);
        // GetServiceList();
        // setOfferList_(_GetOfferAndServiceRequired?.data?.body?.data?.data?.offers);
      }
      //GetSuperStarsList();
    }
  }, [_GetOfferAndServiceRequired?.data]);

  /**
   * Makes an API call to get the service package data based on the given payload.
   * @param {Object} payload - payload containing the parameters to be passed to the API call.
   * @returns {Promise} - A promise that resolves or rejects with the API response.
   */
  const GetServicePackage = (payload) => {
    _GetServiceList.Postdata(
      `${BASE_URL_API()}getservicepackage`,
      true,
      payload,
    );
  };
  useEffect(() => {
    if (_GetServiceList?.data !== null) {
      if (_GetServiceList?.data?.status === 200) {
        setServicePackage_(_GetServiceList?.data?.body.data);
      }
    }
  }, [_GetServiceList.data, _GetServiceList.error]);

  /**
   * Makes an API call to get the service package detail based on the given payload.
   * @param {Object} data - payload containing the parameters to be passed to the API call.
   * @returns {Promise} - A promise that resolves or rejects with the API response.
   */
  const servicePackageDetail = (data) => {
    _ServicePackageDetail.Postdata(
      `${BASE_URL_API()}bikeServicepackage`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_ServicePackageDetail?.data !== null) {
      if (_ServicePackageDetail?.data?.status === 200) {
        // const totalAmount =
        //   parseInt(_ServicePackageDetail?.data?.body?.data?.price) +
        //   parseInt(_ServicePackageDetail?.data?.body?.data?.pickupAmount) +
        //   parseInt(_ServicePackageDetail?.data?.body?.data?.dropAmount);

        // setCreateRequestData_({
        //   key: "amount",
        //   value: parseFloat(
        //     (
        //       totalAmount +
        //       (totalAmount *
        //         parseInt(_ServicePackageDetail?.data?.body?.data?.gst)) /
        //         100
        //     ).toFixed(2),
        //   ),
        // });

        setCreateRequestData_({
          key: "amount",
          value: parseFloat(_ServicePackageDetail?.data?.body?.data?.gstAmount),
        });
        setCreateRequestData_({
          key: "packageType",
          value: _ServicePackageDetail?.data?.body?.data?.servicePackageId,
        });
      } else {
        toast.error(`Something went wrong`, {
          position: "top-center",
        });
      }
      setLoading(false);
    } else if (_ServicePackageDetail.error !== null) {
      setLoading(false);
      toast.error(`Something went wrong`, {
        position: "top-center",
      });
    }
  }, [_ServicePackageDetail.data, _ServicePackageDetail.error]);

  /**
   * Makes an API call to get the slot times based on the given payload.
   * @param {Object} data - payload containing the parameters to be passed to the API call.
   * @returns {Promise} - A promise that resolves or rejects with the API response.
   */
  const GetSlotTimes = (data) => {
    _SlotTimes.Postdata(`${BASE_URL_API()}slotavailability`, true, data);
  };
  useEffect(() => {
    if (_SlotTimes.data !== null) {
      if (_SlotTimes.data.status === 200) {
        console.log("SLOTAVAILABILITY RESPONSE SLOTS:", _SlotTimes.data.body.data.slots);
        setslotTime_(_SlotTimes.data.body.data.slots);
      }
    } else {
      setLoading(false);
    }
  }, [_SlotTimes.data, _SlotTimes.error]);

  /**
   * Makes an API call to create a service request
   * @param {Object} data - payload containing the parameters to be passed to the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const CreateRquest = (data) => {
    setLoading(true);
    _Post_CreateRequest.Postdata(
      `${BASE_URL_API()}serviceRequestByAdmin`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_Post_CreateRequest?.data !== null) {
      if (_Post_CreateRequest?.data?.status === 200) {
        if (_Post_CreateRequest?.data?.body?.success === true) {
          const message = `new servicerequest created for ${_Post_CreateRequest?.payloadData?.name}`;
          logActivity("New ServiceRequest", {
            message,
          });

          toast.success("Request created successfully !", {
            position: "top-center",
          });
          clearCreateRequestData_();
          GetRequestsList(true);
          setAddresslist_([]);
          _Post_CreateRequest.setData(null);
          _Post_CreateRequest.setError(null);
        } else {
          toast.error("something went wrong", {
            position: "top-center",
          });
          setLoading(false);
        }
      } else {
        toast.error("something went wrong", {
          position: "top-center",
        });
        setLoading(false);
        setLoading(false);
      }
    } else if (_Post_CreateRequest.error) {
      toast.error(`${_Post_CreateRequest?.error?.body?.message}`, {
        position: "top-center",
      });
      setLoading(false);
    }
  }, [_Post_CreateRequest?.data, _Post_CreateRequest?.error]);

  //!ServiceBooking Related API ends
  //?-------------------------------------------------------------------------------------------------------

  //?-------------------------------------------------------------------------------------------------------
  //!StoreManager Operational API starts here

  /**
   * SlotDetailUpdate
   * Updates the status of a service booking request.
   * @param {Object} data - contains the new status and changed slot details.
   * @param {string} data.status - can be one of "Accepted", "SlotChangeRequested", or "SlotChangeAccepted"
   * @param {string} data.changedSlot - the new slot details
   * @param {string} data.reason - the reason for the status change
   */
  const SlotDetailUpdate = (data) => {
    setLoading(true);
    _Post_SlotDetails.Postdata(`${BASE_URL_API()}changeServiceStatus`, true, {
      isAdmin: true,
      serviceId: ServiceDetailsStore?.data?.bikeRequest?._id,
      status: data?.status, //Accepted, SlotChangeRequested, SlotChangeAccepted
      changedSlot: data?.changedSlot,
      reason: data?.reason,
    });
  };
  useEffect(() => {
    if (_Post_SlotDetails?.data !== null) {
      if (_Post_SlotDetails?.data?.status === 200) {
        GetRequestsList();
        GetRequestByID(_Post_SlotDetails?.data?.body?.data?.data?.serviceId);
      }
      setLoading(false);
    }
  }, [_Post_SlotDetails?.data]);

  /**
   * Verifies an OTP for a service request.
   * @param {Object} data - contains the serviceId and otp to be verified.
   * @param {string} data.serviceId - id of the service request to verify the OTP for.
   * @param {string} data.otp - OTP to be verified.
   */
  const verifyOTP = (data) => {
    setLoading(true);
    _verifyOTP.Postdata(`${BASE_URL_API()}storeManagerVerifyOtp`, true, data);
  };
  useEffect(() => {
    if (_verifyOTP?.data !== null) {
      if (_verifyOTP?.data?.status === 200) {
        // toast.success("OTP verified successfully")
        storeManagerStatusChange({
          serviceId: ServiceDetailsStore?.data?.bikeRequest?._id,
        });
        // setServiceDetailsData_(ServiceDetailsStore?.data?.bikeRequest?._id);
        // GetRequestByID({
        //   serviceId: ServiceDetailsStore?.data?.bikeRequest?._id,
        // });
      }
    }
    if (_verifyOTP?.error !== null) {
      toast.error("Invalid OTP", { position: "top-center" });
    }
    setLoading(false);
  }, [_verifyOTP.data, _verifyOTP.error]);

  /**
   * StoreManagerStatusChange
   * Updates the status of a service booking request after a store manager verifies the OTP.
   * @param {Object} data - contains the serviceId and new status
   * @param {string} data.serviceId - id of the service request to update the status of
   * @param {string} data.status - new status of the service request
   */
  const storeManagerStatusChange = (data) => {
    _storeManagerStatusChange.Postdata(
      `${BASE_URL_API()}storeManagerStatusChange`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_storeManagerStatusChange?.data !== null) {
      if (_storeManagerStatusChange?.data?.status === 200) {
        toast.success(`OTP verified successfully!`, {
          position: "top-center",
        });
        GetRequestsList();
        GetRequestByID(ServiceDetailsStore?.data?.bikeRequest?._id);
      }
    }
  }, [_storeManagerStatusChange?.data, _storeManagerStatusChange?.error]);

  /**
   * Updates the attendance of a technician
   * @param {Object} data - contains the branchId, technicianId and attendance status
   * @param {string} data.branchId - id of the branch the technician belongs to
   * @param {string} data.technicianId - id of the technician whose attendance needs to be updated
   * @param {string} data.attendanceStatus - new attendance status of the technician
   */
  const SetTechnicianAttendance = (data) => {
    _technicianAttendance.Postdata(
      `${BASE_URL_API()}updateTechnician`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_technicianAttendance.data !== null) {
      if (_technicianAttendance.data.status === 200) {
        const data = {};
        const technician = BranchDetailStore?.branchTechnician?.find(
          (item) => item._id === _technicianAttendance.payloadData.technicianid,
        );
        data.message = `${technician?.name} is marked as ${_technicianAttendance.payloadData.status ? "Present" : "Absent"}`;

        // BranchDetailStore?.branchTechnician?
        logActivity("Technician Attendance", data);
        GetBranchTechnician(localStorage.getItem("BrId"));
        GetRequestsList(true);
        if (ServiceDetailsStore?.data?.bikeRequest?._id) {
          GetRequestByID(ServiceDetailsStore?.data?.bikeRequest?._id);
        }
      }
    } else if (_technicianAttendance.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
    }
  }, [_technicianAttendance.data, _technicianAttendance.error]);

  /**
   * Assigns a technician to a service
   * @param {Object} data - contains the serviceId and technicianId
   * @param {string} data.serviceId - id of the service to which the technician is being assigned
   * @param {string} data.technicianId - id of the technician being assigned to the service
   */
  const AssignTechncianToService = (data) => {
    //console.log("data", data);
    _assignTechncianToService.Postdata(
      `${BASE_URL_API()}assignSuperstars`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_assignTechncianToService.data !== null) {
      if (_assignTechncianToService.data.status === 200) {
        //console.log("data", _assignTechncianToService.data);
        // const technician = BranchDetailStore?.branchTechnician?.find(
        //   (item) => item._id === _assignTechncianToService?.payloadData?.serviceTechnician,
        // );
        // const pickup = BranchDetailStore?.branchTechnician?.find(
        //   (item) => item._id === _assignTechncianToService?.payloadData?.pickUpPerson,
        // );
        // const drop = BranchDetailStore?.branchTechnician?.find(
        //   (item) => item._id === _assignTechncianToService?.payloadData?.dropPerson,
        // );
        console.log("rtyuiop");
        console.log(ServiceDetailsStore);
        const message = `technician assigned for ${ServiceDetailsStore?.data?.bikeRequest?.customerName}`

        logActivity("Assigning Technician", {
          message
        });
        toast.success("Technician assigned successfully", {
          position: "top-center",
        });
        _assignTechncianToService.setData(null);
        setCreateRequestData_({ key: "technician", value: null });
        setCreateRequestData_({ key: "pickupPerson", value: null });
        setCreateRequestData_({ key: "dropPerson", value: null });
        setCreateRequestData_({ key: "dropPerson", value: null });
        setAvailableTechnicianData_(null);

        GetRequestsList(true);
        GetRequestByID(ServiceDetailsStore?.data?.bikeRequest?._id);
        AssignTechnician(false);
      }
    } else if (_assignTechncianToService.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
      _assignTechncianToService.setError(null);
    }
  }, [_assignTechncianToService.data, _assignTechncianToService.error]);

  /**
   * Reschedules a service by posting given slot and updates the service status in the database with the new information
   * @param {Object} data - contains the serviceId and technicianId
   * @param {string} data.serviceId - id of the service to which the technician is being assigned
   * @param {string} data.technicianId - id of the technician being assigned to the service
   */
  const RescheduleService = (data) => {
    _rescheduleService.Postdata(`${BASE_URL_API()}rescheduleSlot`, true, data);
  };
  useEffect(() => {
    if (_rescheduleService.data !== null) {
      if (_rescheduleService.data.status === 200) {
        const message = `service reschedule for ${ServiceDetailsStore?.data?.bikeRequest?.customerName}`
        logActivity("Reschedule Service", {
          message
        });

        toast.success("Slot rescheduled successfully", {
          position: "top-center",
          onClose: () => {
            setReschedule(false);
            // window.location.reload();
          },
        });

        // GetRequestByID()

        GetRequestsList(true);
      }
    } else if (_rescheduleService.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
      _rescheduleService.setError(null);
    }
  }, [_rescheduleService.data, _rescheduleService.error]);

  const setOrRevokeAttendance = (data) => {
    _setOrRevokeAttendance.Postdata(
      `${BASE_URL_API()}SetOrRevokeBranchAttendance`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_setOrRevokeAttendance.data !== null) {
      if (_setOrRevokeAttendance.data.status === 200) {
        logActivity("Overall Branch Attendance updated", {});
        toast.success("Slot Updated Successfully", {
          position: "top-center",
          onClose: () => {
            setSlotModal();
            getStoreSlots();
          },
        });
      }
    } else if (_setOrRevokeAttendance.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
      _setOrRevokeAttendance.setError(null);
    }
  }, [_setOrRevokeAttendance?.data, _setOrRevokeAttendance?.error]);

  /**
   * Get Available Attendance Slots
   * This function sends a POST request to the API to get available attendance slots for the current branch.
   * The response is stored in the `_getDatedSlots` object and is used to update the store with the available slots.
   * If the request is successful, the store is updated and the `_getDatedSlots` object is reset.
   * If the request fails, an error message is displayed.
   */
  const getStoreSlots = () => {
    _getDatedSlots.Postdata(`${BASE_URL_API()}getAvailableAttandance`, true, {
      branchId: localStorage.getItem("BrId"),
    });
  };
  useEffect(() => {
    if (_getDatedSlots.data !== null) {
      if (_getDatedSlots.data.status === 200) {
        const slots = _getDatedSlots.data.body.data || [];
        const seen = new Map();
        const isHoliday = (slot) =>
          slot?.isholiday === 1 || slot?.isholiday === true;
        const isOverridden = (slot) => slot?.isoverridden === 1;
        const pref = (slot) =>
          (isOverridden(slot) ? 2 : 0) + (isHoliday(slot) ? 1 : 0);
        slots.forEach((slot) => {
          const dateStr = String(slot?.startTime || "").split("T")[0];
          if (!dateStr) return;
          const existing = seen.get(dateStr);
          if (!existing) {
            seen.set(dateStr, slot);
            return;
          }
          const existingPref = pref(existing);
          const currentPref = pref(slot);
          if (currentPref > existingPref) {
            seen.set(dateStr, slot);
          } else if (currentPref === existingPref) {
            const existingCreated = new Date(existing?.created || 0).getTime();
            const currentCreated = new Date(slot?.created || 0).getTime();
            if (currentCreated > existingCreated) {
              seen.set(dateStr, slot);
            }
          }
        });
        storeSlotData(Array.from(seen.values()));
        _getDatedSlots.setData(null);
      }
    } else if (_getDatedSlots.error !== null) {
      _getDatedSlots.setError(null);
    }
  }, [_getDatedSlots?.data, _getDatedSlots?.error]);

  /**
   * Updates the available slots for the current branch.
   * This function takes a payload with the start and end time, and the branch ID.
   * It then sends a POST request to the API to update the available slots.
   * If the request is successful, it returns the updated slots.
   * If the request fails, it returns an error message.
   * @param {Object} data - payload containing the parameters to be passed to the API call.
   * @returns {Promise} - A promise that resolves or rejects with the API response.
   */
  const updateSlots = (data) => {
    const next90Dates = Array.from({ length: 90 }, (_, i) => {
      const d = new Date();
      d.setDate(d.getDate() + i);
      return d.toISOString().split("T")[0];
    });
    const payload = {};
    payload.dates = next90Dates;
    payload.branchId = localStorage.getItem("BrId");
    payload.startTime = "09:00";
    payload.endTime = "18:00";
    payload.isexception = 0;

    _setSlots.Postdata(`${BASE_URL_API()}technicianAvailablity`, true, payload);
  };
  useEffect(() => {
    if (_setSlots.data !== null) {
      if (_setSlots.data.status === 200) {
      }
    } else if (_setSlots.error !== null) {
      toast.error("something went wrong", { position: "top-center" });
    }
  }, [_setSlots.data, _setSlots.error]);

  //!StoreManager Operational API ends here
  //?-------------------------------------------------------------------------------------------------------

  //?-------------------------------------------------------------------------------------------------------
  //!Unused APIs Starts Here
  /**
   * Gets the list of bike service types available for booking
   * @param {boolean} Auth - Whether to include the Authorization header in the API call
   * @returns {Promise} - A promise that resolves or rejects with the API response
   */
  const GetbikeServiceTypeList = (Auth) => {
    _GetbikeServiceTypeList.Getdata(`${BASE_URL_API()}bikeServiceType`, true);
  };
  useEffect(() => {
    if (_GetbikeServiceTypeList?.data !== null) {
      if (_GetbikeServiceTypeList?.data?.status === 200) {
        setServiceType_(_GetbikeServiceTypeList?.data?.body?.data);
        GetAddressTypeList();
        const payload = {
          bikeid: RequestUserStore?.bike_id,
          bikeType: RequestUserStore?.bikeType,
          gearType: RequestUserStore?.gearSystem,
          serviceType: RequestUserStore?.serviceType,
        };
      }
    }
  }, [_GetbikeServiceTypeList?.data]);

  const GetServicePackageData = (id) => {
    // //console.log("Entereing");
    // let url;
    // if (id) {
    //   url = `${BASE_URL_API()}getServicePackage?bikeid=${id}`;
    // } else {
    //   url = `${BASE_URL_API()}getservicepackage`;
    // }
    // _GetSericePackage.Getdata(url, true);
  };
  useEffect(() => {
    // //console.log("ghjkl");
    if (_GetSericePackage.data !== null) {
      if (_GetSericePackage.data.status === 200) {
        // //console.log(_GetSericePackage?.data);
        setServicePackage_(_GetSericePackage?.data?.body?.data);
      }
    }
  }, [_GetSericePackage.data, _GetSericePackage.error]);

  const GetSuperStarsList = (Auth) => {
    _GetSuperStarsList.Getdata(`${BASE_URL_API()}superstars`, true);
  };
  useEffect(() => {
    if (_GetSuperStarsList?.data !== null) {
      if (_GetSuperStarsList?.data?.status === 200) {
        setSuperStarList_(_GetSuperStarsList?.data?.body?.data?.data);
      }
      setLoading(false);
    }
  }, [_GetSuperStarsList?.data]);

  /**
   * Sets the initial attendance of technicians in a branch.
   * @param {Object} data - payload containing the branchId
   * @param {string} data.branchId - id of the branch for which the attendance needs to be set
   */
  const setInitialAttendance = () => {
    _initialAttendance.Postdata(
      `${BASE_URL_API()}updateBranchTechnician`,
      true,
      {
        branchId: localStorage.getItem("BrId"),
      },
    );
  };

  //?-------------------------------------------------------------------------------------------------------
  //!Warranty APIs Starts Here

  const GetStoreWarranties = (data) => {
    _GetStoreWarranties.Postdata(
      `${BASE_URL_API()}v1/war/store-warranties`,
      true,
      data,
    );
  };
  const GetWarrantyById = (id) => {
    _GetWarrantyById.Getdata(
      `${BASE_URL_API()}v1/war/store-warranty/${id}`,
      true,
    );
  };

  const GetWarrantyService = (id) => {
    _GetWarrantyService.Getdata(
      `${BASE_URL_API()}v1/war/store-warranty-service/${id}`,
      true,
    );
  };

  const GetWarrantyStatuses = () => {
    _GetWarrantyStatuses.Getdata(
      `${BASE_URL_API()}v1/war/store-warranty-statuses`,
      true,
    );
  };

  const CreateWarrantyServiceRequest = (data) => {
    _CreateWarrantyServiceRequest.Postdata(
      `${BASE_URL_API()}v1/war/store-warranty-service-request`,
      true,
      data,
    );
  };

  //!Warranty APIs Ends Here
  //?-------------------------------------------------------------------------------------------------------

  //!Unused APIs Ends Here
  //?-------------------------------------------------------------------------------------------------------

  const GetAvailableTechnician = (data) => {
    _getAvailableTechncian.Postdata(
      `${BASE_URL_API()}getsuperstar`,
      true,
      data,
    );
  };
  useEffect(() => {
    if (_getAvailableTechncian.data !== null) {
      if (_getAvailableTechncian.data.status === 200) {
        setAvailableTechnicianData_(_getAvailableTechncian?.data?.body?.data);
        _getAvailableTechncian.setData(null);
      }
    } else if (_getAvailableTechncian.error !== null) {
      toast.error("Something went wrong", {
        position: "top-center",
      });
      _getAvailableTechncian.setError(null);
    }
  }, [_getAvailableTechncian.data, _getAvailableTechncian.error]);

  // useEffect(()=>{
  //   //console.log("comming")
  //   if(  RequestUserStore?.bikeType && RequestUserStore?.gearSystem && RequestUserStore?.serviceType){
  //       const payload = {
  //         bikeid: RequestUserStore?.bike_id,
  //         bikeType: RequestUserStore?.bikeType,
  //         gearType: RequestUserStore?.gearSystem,
  //         serviceType: RequestUserStore?.serviceType,
  //       };
  //       //console.log("SWERTYUIOP")

  //   // GetServiceList(payload);
  //   }

  // },[RequestUserStore?.bikeid,RequestUserStore?.bikeType,RequestUserStore?.gearSystem,RequestUserStore?.serviceType])

  return {
    GetRequestsList,
    GetbikeTypesList,
    GetCityList,
    CheckMobile,
    _Post_MobileNumber,
    CreateRquest,
    GetRequestByID,
    SlotDetailUpdate,
    GetAddressTypeList,
    _GetRequestByID,
    GetBranchList,
    servicePackageDetail,
    GetSlotTimes,
    verifyOTP,
    verifyPincode,
    GetOfferAndServiceRequiredList,
    GetBranchData,
    GetBranchTechnician,
    AddSuperStar,
    GetServicePackageData,
    SetTechnicianAttendance,
    GetAvailableTechnician,
    AssignTechncianToService,
    RescheduleService,
    setInitialAttendance,
    GetServiceMan,
    EditTechnician,
    updateSlots,
    getStoreSlots,
    setOrRevokeAttendance,
    GetBrandList,
    GetgearSystemList,
    GetServicePackage,
    deleteSuperstar,
    _deleteSuperstar,
    verifyEmailIdForNewRequest,
    GetStoreWarranties,
    _GetStoreWarranties,
    GetWarrantyById,
    _GetWarrantyById,
    GetWarrantyService,
    _GetWarrantyService,
    GetWarrantyStatuses,
    _GetWarrantyStatuses,
    CreateWarrantyServiceRequest,
    _CreateWarrantyServiceRequest,
  };
};

export default Api;
